module.exports = __webpack_public_path__ + "img/microteaching_classroom_card_image.ca90c033.jpg";